/**
 * Added Checkout Page
 */

import { Layout } from '@/data/types/Layout';

export const getCheckOutPage = (): Layout => ({
	name: 'DoubleStack',
	slots: {
		first: [{ name: 'CheckOut', id: 'check-out' }],
		footer: [{ name: 'Footer', id: 'footer' }],
	},
});
